import {Component, Input, OnChanges, ViewEncapsulation, SimpleChanges, OnInit, signal, computed} from '@angular/core';
import { SignedUserDTO } from '@signature-it/ngx-generic/models';
import {ShareDataService} from '@signature-it/ngx-generic/services';
import {GenericConfig} from '@signature-it/ngx-generic/config';

@Component({
    selector: 'main-header-user-details',
    templateUrl: './user-details.html',
    styleUrls: ['./user-details.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MainHeaderUserDetailsComponentGeneric implements OnChanges, OnInit {

    @Input() user: SignedUserDTO;
    userName: string;
    userFields = signal(GenericConfig.userDetailsFieldName || 'full_name');
    userDetailsFields = computed(() => {
        return Array.isArray(this.userFields()) ? this.userFields() : [ this.userFields()];
    });
    constructor(
        public shareDataService: ShareDataService
    ) {}
    ngOnChanges(changes: SimpleChanges): void {}
    ngOnInit(): void {
    }
}
